import { useCallback, useEffect, useRef, useMemo } from 'react';

import useOtherTopicsName from './useOtherTopicsName';
import useTopics from './useTopics';
import { PARAM_OTHER_TOPICS } from '../constants/queryParams';
import { OTHER_TOPICS } from '../constants/types';
import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';

const useTopicsOtherTopics = ({ rowsToDisplay }) => {
  const fetchDone = useRef(false);

  const { totalAllTopics, setTotalAllTopics, itemsPerRow } =
    useTopicsIndexContext();
  const params = { [PARAM_OTHER_TOPICS]: true };
  const {
    topics,
    totalTopics,
    isFetchingTopics,
    setPage,
    handleFetchTopics,
    updateTopicApproval,
  } = useTopics({ params });
  const name = useOtherTopicsName();

  const newTopics = useMemo(() => {
    const newTotal = fetchDone.current
      ? topics.length
      : Math.min(itemsPerRow * rowsToDisplay, topics.length);

    return newTotal === topics.length ? topics : topics.slice(0, newTotal);
  }, [topics, fetchDone.current]);

  const loadNextPage = useCallback(() => {
    fetchDone.current = true;
    setPage((previousPage) => previousPage + 1);
  }, []);

  useEffect(() => {
    setTotalAllTopics({
      ...totalAllTopics,
      [OTHER_TOPICS]: {
        totalTopics,
        isFetchingTopics,
      },
    });
  }, [totalTopics, isFetchingTopics]);

  return {
    name,
    topics: newTopics.map((topic) => ({
      ...topic,
      typeTopic: OTHER_TOPICS,
    })),
    totalTopics,
    isFetchingTopics,
    params,
    loadNextPage,
    handleFetchTopics,
    updateTopicApproval,
  };
};

export default useTopicsOtherTopics;
